import React, { Component } from 'react';
import { Form, Input, Button, message, Select, Icon } from 'antd';
import Country from 'country-data';
import { minimalTimezoneSet } from 'compact-timezone-list';
import { connect } from 'react-redux';
import { SetupAction } from '../../actions';
import { bindActionCreators } from 'redux';
import { FormWrapper } from './style';
import { postExchange, putExchange } from '../../common/fetch';
// import { GLOBAL_LANGUAGE } from '../../config/media';

// NOTE Insert the Tehran data
minimalTimezoneSet.splice(15, 0, {
	label: '(GMT+03:30) Tehran',
	offset: '+03:30',
	tzCode: 'Asia/Iran',
});

const { Item } = Form;

class Step1 extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isDisabled: false,
			display_content: '0',
			button_top: '-40px',
		}
	}

	componentDidMount() {
		const { biz } = this.props;
		const { setFieldsValue } = this.props.form;
		setFieldsValue({
			EXCHANGE_NAME: biz.EXCHANGE_NAME,
			DEFAULT_COUNTRY: biz.DEFAULT_COUNTRY,
			// TIME_ZONE: biz.TIME_ZONE,
			// LANGUAGE: biz.LANGUAGE,
		});
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.display_content === '0') {
			setTimeout(() => {
				this.setState({ button_top: "0px" });
			}, 1300);
			setTimeout(() => {
				this.setState({ display_content: "1" });
			}, 1500);
		}
	}


	handleSubmit = async (e) => {
		e.preventDefault();
		const { biz } = this.props;
		if (biz.hasOwnProperty('id')) {
			this.updateExchange();
		} else {
			this.createExchange();
		}
	};

	updateExchange = async () => {
		this.setState({ isDisabled: true });
		const { biz, setupActions } = this.props;
		const { getFieldsValue, getFieldValue } = this.props.form;

		const body = getFieldsValue();
		try {
			const exchangeBody = {
				name: getFieldValue('EXCHANGE_NAME'),
				id: biz.id,
				info: {
					biz: body,
					public: {
						title: getFieldValue('EXCHANGE_NAME'),
						country: getFieldValue('DEFAULT_COUNTRY'),
					},
					is_temp: biz.is_temp,
				},
			};
			delete exchangeBody.info.biz.id;
			await putExchange(exchangeBody);
			const data = { ...biz, ...body };
			setupActions.updateBiz({
				data,
			});
			this.setState({ isDisabled: false });
		} catch (error) {
			message.error(error.data.message);
			this.setState({ isDisabled: false });
		}
		this.props.onOk();
	};

	createExchange = async () => {
		const { setupActions } = this.props;
		const { getFieldValue, getFieldsValue } = this.props.form;
		const body = getFieldsValue();
		try {
			const exchangeBody = {
				name: getFieldValue('EXCHANGE_NAME'),
				is_public: false,
				info: {
					is_temp: true,
					public: {
						title: getFieldValue('EXCHANGE_NAME'),
						country: getFieldValue('DEFAULT_COUNTRY'),
					},
					biz: body,
				},
			};
			const res = await postExchange(exchangeBody);
			setupActions.updateBiz({
				id: res.data.id,
				is_temp: true,
				activation_code: res.data.activation_code,
				...body,
			});
			this.props.onOk();
		} catch (error) {
			message.error(error.data.message);
		}
	};

	renderCountries = () => {
		const country = Country.countries.all
			.filter((item) => {
				return item.status === 'assigned';
			})
			.sort((a, b) => {
				const nameA = a.name.toUpperCase(),
					nameB = b.name.toUpperCase();
				if (nameA < nameB) {
					return -1;
				}
				if (nameA > nameB) {
					return 1;
				}
				return 0;
			});
		return country.map((item) => {
			return (
				<Select.Option key={item.alpha2}>
					{item.emoji} {item.name}
				</Select.Option>
			);
		});
	};

	renderTimezone = () => {
		return minimalTimezoneSet.map((item) => {
			if (item.label.toLowerCase().indexOf('tokyo') >= 0) {
				return (
					<Select.Option key="Asia/Seoul" value={item.tzCode}>
						<Icon
							type="clock-circle"
							className="mini-icon"
						/>
						(GMT+09:00) Seoul
					</Select.Option>
				);
			}
			return (
				<Select.Option key={item.tzCode} value={item.tzCode}>
					<Icon
						type="clock-circle"
						className="mini-icon"
					/>
					{item.label}
				</Select.Option>
			);
		});
	};

	render() {
		const { getFieldDecorator, getFieldsError, getFieldValue } = this.props.form;
		return (
			<FormWrapper>
				<Form onSubmit={this.handleSubmit} className="general-form">
					<Item style={{ marginTop: '24px' }}>
						<h3 className="form-label">Exchange Name</h3>
						<p>
							The name is used to display and identify your exchange.
						</p>
						{getFieldDecorator('EXCHANGE_NAME',
							{
								rules: [
									{ required: true, message: 'Please input your Exchange Name!' },
									{ pattern: /^[^0-9][\w\W]*$/, message: 'The first character should not be a number.' },
								],
							}
						)(
							<Input placeholder="Exchange Name" />
						)}
						<p>
							Only alphanumeric characters. No specials characters allowed.
						</p>
					</Item>
					{/* <div className='divider'></div> */}
					{/* <Item>
						<h3 className="form-label">Country</h3>
						<p>
							This will be your exchanges primary location to promote and operate your exchange from. In the case of global crypto exchanges please pick global.
						</p> */}
					{/* {getFieldDecorator('DEFAULT_COUNTRY')(
							<Select>
								<Select.Option value="">
									<div className="global-menu">
										<img src={GLOBAL_LANGUAGE} className="mini-icon" alt="global-menu" />
										Global
									</div>
								</Select.Option>
								{this.renderCountries()}
							</Select>
						)} */}
					{/* </Item> */}
					{/*<Item>
						<h3 className="form-label">Time Zone</h3>
						<p>
							Enter your time zone in which you will primarily function
							under. Setting the correct time zone for your exchange will
							determine trading times and other event based labels on you
							exchange.
						</p>
						{getFieldDecorator('TIME_ZONE')(
							<Select>
								<Select.Option value="UTC">
									<Icon
										type="clock-circle"
										className="mini-icon"
									/>
									UTC
								</Select.Option>
								{this.renderTimezone()}
							</Select>
						)}
					</Item>
					<Item className="last">
						<h3 className="form-label">Language</h3>
						<p>d
							The default language used when users visit your exchange.
						</p>
						{getFieldDecorator('LANGUAGE')(
							<Select>
								<Select.Option value="en">
									<div className="global-menu">
										<img src={FLAG_UK} className="flag-icon" alt="flag-en" />
										English
									</div>
								</Select.Option>
								<Select.Option value="ko">
									<div className="global-menu">
										<img src={FLAG_KO} className="flag-icon" alt="flag-ko" />
										Korean
									</div>
								</Select.Option>
							</Select>
						)}
					</Item>
					<Item>
						<h3>Exchange Description</h3>
						<p>
							In a couple of sentences, share why your exchange is
							unique. This description can be used to market your
							exchange and help towards crowd-sourcing liquidity
						</p>
						{getFieldDecorator('EXCHANGE_DESC')(
							<TextArea placeholder="Exchange Description" />
						)}
					</Item> */}
					<div className='smooth-drop'>
						<div className='animation-bounce'>
							<div className='align-center'>
								<div className='details-container' style={{ opacity: this.state.display_content }}>
									<div className='info-icon'>i</div>
									<div>Note: <span>All details can be changed at a later date</span></div>
								</div>
							</div>
							<Button
								block
								type="primary"
								htmlType="submit"
								style={{ top: this.state.button_top }}
								disabled={this.state.isDisabled ||
									(getFieldsError().EXCHANGE_NAME && getFieldsError().EXCHANGE_NAME.length) ||
									(getFieldValue('EXCHANGE_NAME') === '')
								}
							>
								Next
							</Button>
						</div>
					</div>
				</Form>
			</FormWrapper>
		);
	}
}

const General = Form.create({ name: 'general form' })(Step1);

const mapStateToProps = (state) => {
	return {
		biz: state.setup.biz,
		tech: state.setup.tech,
	};
};

const mapDispatchToProps = (dispatch) => ({
	setupActions: bindActionCreators(SetupAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(General);
